import { SVG } from '../SVG'

const SearchIcon = ({ style = {}, ...props }) => (
  <SVG
    width='22'
    height='21'
    viewBox='0 0 22 21'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'var(--color-black)', ...style }}
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.2336 15.2621L18.5329 20.5613C19.1176 21.1461 20.0664 21.1461 20.6512 20.5613C21.2359 19.9766 21.2359 19.0278 20.6512 18.443L15.3519 13.1438C16.2146 11.8737 16.7187 10.3405 16.7187 8.68945C16.7187 4.30442 13.164 0.75 8.77929 0.75C4.39464 0.75 0.839844 4.30479 0.839844 8.68945C0.839844 13.0741 4.39464 16.6289 8.77929 16.6289C10.4304 16.6289 11.9636 16.1247 13.2336 15.2621ZM14.1606 8.68945C14.1606 11.6618 11.7512 14.0712 8.77892 14.0712C5.80661 14.0712 3.39722 11.6618 3.39722 8.68945C3.39722 5.71714 5.80699 3.30775 8.77929 3.30775C11.7516 3.30775 14.161 5.71714 14.161 8.68945H14.1606Z'
    />
  </SVG>
)

export default SearchIcon
